<template>
  <div>
    <div class="flex items-center tablet:justify-start gap-[10px] tablet:gap-4 mb-4 pb-4 border-b border-[#EFEFEF]"
    :class="isPartnerQuote ? 'mobile:justify-between' : 'mobile:justify-start' ">
      <div v-if="isPartnerQuote" :class="['group', { 'active': isImages }]" @click="buttonClicked('Notes')">
        <div class="flex items-center gap-1 laptop:gap-2 cursor-pointer">
          <div
          class="flex items-center justify-center mobile:h-[30px] mobile:w-[30px] tablet:h-[40px] tablet:w-[40px] border-1 !border-dashed rounded-full overflow-hidden border-[#CCCCCC]  group-[.active]:!border-[#092E87]">
          <span
          class="m-1 mobile:w-[20px] mobile:h-[20px] tablet:w-[26px] tablet:h-[26px] flex items-center justify-center rounded-full bg-[#fff] group-[.active]:bg-[#EFEFEF]">
          <img src="../../assets/images/blue-tick.png" class="group-[.active]:block hidden mobile:w-[15px] mobile:h-[15px ] tablet:w-[20px] tablet:h-[20px] object-cover">
          <img src="../../assets/images/gray-tick.png" class="group-[.active]:hidden block mobile:w-[15px] mobile:h-[15px ] tablet:w-[20px] tablet:h-[20px] object-cover">
              <!-- <i class="fa fa-check text-[#CCCCCC] group-[.active]:text-[#092E87]"></i> -->
            </span>
          </div>
          <p class="mb-0 text-[12px] laptop:text-[16px] text-[#999999] group-[.active]:text-[#092E87]">Add Images</p>
        </div>
      </div>
      <div :class="['group', { 'active': isCreateQuote }]" @click="buttonClicked('QuoteItems')">
        <div class="flex items-center gap-1 laptop:gap-2 cursor-pointer">
          <div
            class="flex items-center justify-center mobile:h-[30px] mobile:w-[30px] tablet:h-[40px] tablet:w-[40px] border-1 !border-dashed rounded-full overflow-hidden border-[#CCCCCC]  group-[.active]:!border-[#092E87]">
            <span
              class="m-1 mobile:w-[20px] mobile:h-[20px] tablet:w-[26px] tablet:h-[26px] flex items-center justify-center rounded-full bg-[#fff] group-[.active]:bg-[#EFEFEF]">
              <img src="../../assets/images/blue-tick.png" class="group-[.active]:block hidden mobile:w-[15px] mobile:h-[15px ] tablet:w-[20px] tablet:h-[20px] object-cover">
              <img src="../../assets/images/gray-tick.png" class="group-[.active]:hidden block mobile:w-[15px] mobile:h-[15px ] tablet:w-[20px] tablet:h-[20px] object-cover">
              <!-- <i class="fa fa-check text-[#CCCCCC] group-[.active]:text-[#092E87]"></i> -->
            </span>
          </div>
          <p class="mb-0 text-[12px] laptop:text-[16px] text-[#999999] group-[.active]:text-[#092E87]">Create Quote</p>
        </div>
      </div>
      <div :class="['group', { 'active': isFinalizeQuote }]" @click="buttonClicked('QuoteSummary')">
        <div class="flex items-center gap-1 laptop:gap-2 cursor-pointer">
          <div
          class="flex items-center justify-center mobile:h-[30px] mobile:w-[30px] tablet:h-[40px] tablet:w-[40px] border-1 !border-dashed rounded-full overflow-hidden border-[#CCCCCC]  group-[.active]:!border-[#092E87]">
          <span
          class="m-1 mobile:w-[20px] mobile:h-[20px] tablet:w-[26px] tablet:h-[26px] flex items-center justify-center rounded-full bg-[#fff] group-[.active]:bg-[#EFEFEF]">
          <img src="../../assets/images/blue-tick.png" class="group-[.active]:block hidden mobile:w-[15px] mobile:h-[15px ] tablet:w-[20px] tablet:h-[20px] object-cover">
          <img src="../../assets/images/gray-tick.png" class="group-[.active]:hidden block mobile:w-[15px] mobile:h-[15px ] tablet:w-[20px] tablet:h-[20px] object-cover">
              <!-- <i class="fa fa-check text-[#CCCCCC] group-[.active]:text-[#092E87]"></i> -->
            </span>
          </div>
          <p class="mb-0 text-[12px] laptop:text-[16px] text-[#999999] group-[.active]:text-[#092E87]">Finalize Quote
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},

  data() {
    return {
      isImages: true,
      isCreateQuote: false,
      isFinalizeQuote: false,
      step: 1,
    };
  },
  computed: {
    ...mapGetters(["quoteDetail", "componentState"]),

    isPartnerQuote() {
      return (this.quoteDetail?.partner_info?.id > 0 && this.quoteDetail?.partner_info?.status != '0') || false
    },
  },

  watch: {
    componentState: function () {
      this.setButtons(this.componentState);
    },
  },

  mounted() {
    this.setButtons(this.componentState);
  },

  methods: {
    ...mapActions(["setCommponent"]),

    buttonClicked(stateData) {
      if (this.step == 1 && stateData == "Notes") {
        this.setCommponent(stateData);
      } else if (this.step == 2 && stateData == "Notes") {
        this.setCommponent(stateData);
      } else if (
        this.step == 3 &&
        (stateData == "Notes" || stateData == "QuoteItems")
      ) {
        this.setCommponent(stateData);
      }
    },

    setButtons(data) {
      this.resetButtons();
      if (data == "Notes") {
        this.step = 1;
        this.isImages = true;
      } else if (data == "QuoteItems") {
        this.step = 2;
        this.isImages = true;
        this.isCreateQuote = true;
      } else if (data == "QuoteSummary") {
        this.step = 3;
        this.isImages = true;
        this.isCreateQuote = true;
        this.isFinalizeQuote = true;
      }
    },
    resetButtons() {
      (this.isImages = false),
        (this.isCreateQuote = false),
        (this.isFinalizeQuote = false);
    },
  },
};
</script>